export default __webpack_public_path__ + "static/media/settings.b13bd4ce.svg";